<script setup lang="ts"></script>
<template>
    <div class="min-h-screen flex items-center justify-center text-center">
        <div>
            <h1>404</h1>
            <p>Page not found</p>
        </div>
    </div>
</template>
